<ion-content>

  <ion-header>
    <ion-toolbar mode="ios">
      <ion-button (click)="close()" fill="clear" color="dark" class="ion-no-padding">
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
      <ion-title class="ion-no-padding">
        <ion-img [src]="dataServ.rData.dark_logo" *ngIf="dataServ.rData.dark_logo[0]"></ion-img>
      </ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-grid>

    <ion-row>
      <ion-col size="12">
        <ion-text color="primary" class="ion-text-center">
          <h1><b [innerHtml]="data.menu_item_name | caption | translate"></b></h1>
        </ion-text>
      </ion-col>
    </ion-row>

    
  </ion-grid>
</ion-content>